module.exports = __webpack_public_path__ + "static/media/profile.c5c90730.png";